import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/user.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logotype"
}, null, -1)
const _hoisted_2 = { class: "users_card__info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.$props.userData != null)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "users_card",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirect && _ctx.redirect(...args)))
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$props.userData.login), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.Ti18N("users.lenOfList")) + ": " + _toDisplayString(_ctx.$props.userData.words), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.Ti18N("users.latest")) + ": " + _toDisplayString(_ctx.$props.userData.title), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.Ti18N("users.lenOfFolders")) + ": " + _toDisplayString(_ctx.$props.userData.folders), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}